import { render, staticRenderFns } from "./mmxg.vue?vue&type=template&id=4717f5d2&scoped=true&"
import script from "./mmxg.vue?vue&type=script&lang=js&"
export * from "./mmxg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4717f5d2",
  null
  
)

export default component.exports